import { render, staticRenderFns } from "./simple-slick.vue?vue&type=template&id=e5d1d158&"
import script from "./simple-slick.vue?vue&type=script&lang=js&"
export * from "./simple-slick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports